import script from "./BaseList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseList.vue?vue&type=script&setup=true&lang=ts"

import "./BaseList.vue?vue&type=style&index=0&id=2a65cc5b&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a65cc5b"]])

export default __exports__